export const WEEK_DAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const ;

export type WeekDay = typeof WEEK_DAYS[number];
export interface SchedulerData {
  "description": string,
  "dateDescription": string,
  notes?: string;
  hours: Partial<Record<WeekDay, string[]>>;
}

export enum DropoffLocationSupervision {
  ONSITE_PERSONNEL = 'On-site personnel',
  SECURITY_CAMERAS = 'Security cameras'
}

export enum DropoffLocationFunding {
  PAY_AS_YOU_THROW = 'PAYT',
  PERMIT_FEE = 'Permit/Utility Fee',
  TAXES = 'General Fund/Property Taxes',
  OTHER = 'Other',
}

export enum DropoffLocationSectorsServed {
  INDUSTRIAL = 'Industrial',
  COMMERCIAL = 'Commercial',
  RESIDENTIAL = 'Residential',
}

export enum DropoffLocationResidentEligibility {
  NO_RESTRICTION = 'No restriction',
  RESTRICTED_TO_JURISDICTION = 'Restricted to jurisdiction',
  OTHER = 'Other',
}

export enum DropoffLocationMachineryUsed {
  COMPACTOR = 'Compactor',
  ROLL_OFF_CONTAINER = 'Roll-off container',
  GLASS_CRUSHER = 'Glass crusher',
  HORIZONTAL_BALER = 'Horizontal Baler',
  VERTICAL_BALER = 'Vertical Baler'
}

export enum DropoffLocationCollectionFormat {
  FIBER_CONTAINER_DUAL = 'Fiber container dual',
  SINGLE_STREAM = 'Single stream',
  OCC_ONLY = 'OCC only',
  VARIES = 'Varies',
  GLASS_AND_SINGLE_STREAM = 'Glass and single stream',
  OTHER = 'Other',
  MIXED_WASTE_COLLECTION = 'Mixed waste collection',
  SOURCE_SEPARATED = 'Source separated'
}

export interface NDBDropOffLocation {
  id: string;
  name: string;
  address: {
    street: string;
    locality: string;
    region: string;
    postalCode: string;
    country: string;
  };
  isAdministrator: boolean;
  isServicedBy: boolean;
}
export interface NDBDropOffLocationDetails {
  id: string;
  name: string;
  address: Partial<{
    street: string;
    locality: string;
    region: string;
    postalCode: string;
    country: string;
  }>;
  coordinates: {
    latitude: number;
    longitude: number;
  };
  contactName: string;
  guidelinesUrl: string | null;
  websiteUrl: string | null;
  contactPhoneNumber: string | null;
  householdsServed: number | null;
  machineryUsed: Array<string> | null;
  residentEligibility: DropoffLocationResidentEligibility | null;
  collectionFormat: string | null;
  ownedBy: string | null;
  operatedBy: string | null;
  sectorsServed: DropoffLocationSectorsServed[] | null;
  publicNotes: string | null;
  supervision: DropoffLocationSupervision[] | null;
  funding: DropoffLocationFunding[] | null;
  isAdministrator: boolean;
  isServicedBy: boolean;
  hoursOfOperation: (DropOffHoursOfOperation|SchedulerData)[];
  administratorNotes: {text: string , date_recorded: string, who_updated: string} | null;
  materialsAccepted: Array<number>;
}

export interface NDBDropOffLocationSearch {
  id: string;
  name: string;
  address: {
    street: string;
    locality: string;
    region: string;
    postalCode: string;
    country: 'USA';
  };
  // hasAdministrator: true;
  administratingCommunity: {name: string; code: string};
}

export interface DropOffHoursOfOperationRange {
  start: {
    hour: number;
    minute: number;
  };
  end: {
    hour: number;
    minute: number;
  };
}
export interface DropOffHoursOfOperation {
  description: string;
  dateDescription: string;
  notes: string;
  hours: {
    monday: DropOffHoursOfOperationRange[] | string;
    tuesday: DropOffHoursOfOperationRange[]| string;
    wednesday: DropOffHoursOfOperationRange[]| string;
    thursday: DropOffHoursOfOperationRange[]| string;
    friday: DropOffHoursOfOperationRange[]| string;
    saturday: DropOffHoursOfOperationRange[]| string;
    sunday: DropOffHoursOfOperationRange[]| string;

  };
}

export interface NDBDropOffLocationUpdate {
  name: string;
  address: {
    street: string;
    locality: string;
    region: string;
    postalCode: string;
    country: string;
  };
  coordinates: {
    latitude: number;
    longitude: number;
  };
  hoursOfOperation: DropOffHoursOfOperation[];
  guidelinesUrl: string;
  websiteUrl: string;
  householdsServed: number;
  machineryUsed: string[];
  residentEligibility: DropoffLocationResidentEligibility | null;
  collectionFormat: string;
  ownedBy: string;
  operatedBy: string;
  sectorsServed: DropoffLocationSectorsServed[];
  contactPhoneNumber: string;
  publicNotes: string;
  administratorNotes: {text: string , date_recorded?: string, who_updated: string} | string;
  supervision: DropoffLocationSupervision[];
  funding: DropoffLocationFunding[] | null;
  materialsAccepted: Array<number>;
  isTerminated: boolean;
}

